module.exports = __webpack_public_path__ + "static/media/compare_connect.de3a7886.svg";